<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     批量新建参数
  +---------------------------------------------------------------------------------------
-->

<template>
	<el-dialog class="user-editor" :title="uid == -1 ? '新建成员' : '成员编辑'" :visible.sync="dialogShow" width="600px" v-loading="postloading" :close-on-click-modal="false" :modal-append-to-body="false">
		<template>
			<el-form ref="alarmForm" v-loading="loading" :model="userForm" :rules="rules" label-width="100px" label-position="left" class="f-form">
				<el-form-item prop="username" label="姓名" style="width: 100%">
					<el-input :controls="false" v-model="userForm.username" clearable placeholder="" style="width: 100%" />
				</el-form-item>
				<el-form-item prop="mobile" label="手机号" style="width: 100%">
					<el-input :controls="false" v-model="userForm.mobile" clearable placeholder="" style="width: 100%" />
				</el-form-item>
				<el-form-item v-if="uid == -1" prop="password" label=" 初始密码" style="width: 100%">
					<el-input :controls="false" v-model="userForm.password" clearable placeholder="" style="width: 100%" />
				</el-form-item>

				<el-form-item label="角色" style="width: 100%">
					<!-- <el-input :controls="false" v-model="userForm.roleid" clearable placeholder="消息内容" style="width: 100%" /> -->
					<el-select v-model="userForm.roleid" placeholder="请选择" filterable clearable style="width: 100%">
						<el-option v-for="role in roleArr" :key="role.roleid" :label="role.desc" :value="role.roleid" />
					</el-select>
				</el-form-item>
				<el-form-item label="性别" style="width: 100%">
					<el-select v-model="userForm.gender" placeholder="请选择" filterable clearable style="width: 100%">
						<el-option v-for="gender in genderArr" :key="gender.gender" :label="gender.title" :value="gender.gender" />
					</el-select>
				</el-form-item>
				<el-form-item label="工号" style="width: 100%">
					<el-input :controls="false" v-model="userForm.worker_no" clearable placeholder="" style="width: 100%" />
				</el-form-item>
				<el-form-item label="邮箱" style="width: 100%">
					<el-input :controls="false" v-model="userForm.email" clearable placeholder="" style="width: 100%" />
				</el-form-item>
			</el-form>

			<div class="mt-lg text-center">
				<el-button class="extend" plain @click="dialogShow = false">取消</el-button>
				<el-button class="extend" type="success" :loading="postloading" @click="submit">提交</el-button>
			</div>
		</template>
	</el-dialog>
</template>

<script>
import { createUserApi, getAllRoleApi, editUserApi, getUserDetailApi } from '@/api/sys/userApi'
export default {
	name: 'UserEditor',
	components: {},
	props: {
		show: {
			type: Boolean,
			default: false
		},
		uid: {
			type: Number,
			default: null
		}
	},
	data () {
		return {
			rules: {
				mobile: [{ required: true, message: '请填写手机号码', trigger: 'blur' }],
				password: [{ required: true, message: '请填写密码', trigger: 'blur' }],
				username: [{ required: true, message: '请填写姓名', trigger: 'blur' }]
			},
			postloading: false,
			loading: false,
			currentIdx: undefined,
			userForm: {
				mobile: '',
				password: '',
				username: '',
				gender: undefined,
				email: '',
				worker_no: undefined,
				remark: '',
				roleid: undefined
			},
			roleArr: [],
			genderArr: [
				{
					gender: 1,
					title: '男'
				},
				{
					gender: 2,
					title: '女'
				}
			]
		}
	},

	computed: {
		dialogShow: {
			get () {
				return this.show
			},
			set (val) {
				this.$emit('update:show', val)
			}
		}
	},
	created () {
		this.fetchData()
	},
	mounted () { },

	methods: {
		fetchData () {
			if (this.uid != -1) {
				this.loading = true
				getUserDetailApi({ uid: this.uid }).then(res => {
					this.loading = false
					this.userForm = Object.assign({}, res.data)
					this.userForm.roleid = this.userForm.roleid ? this.userForm.roleid : null
					if (!this.userForm.gender) this.userForm.gender = null
				})
			}
			getAllRoleApi().then(res => {
				if (!res.errno) {
					this.roleArr = res.data.list
					this.loading = false
				}
			})
		},
		submit () {
			Promise.all([this.$refs['alarmForm'].validate()]).then(() => {
				// 通过表单校验
				if (this.uid == -1) {
					createUserApi(this.userForm)
						.then(res => {
							this.postLoading = false
							if (!res.errno) {
								// 操作成功直接跳转至工单详情
								this.$message.success('用户创建成功')
								this.dialogShow = false
								this.$emit('change')
							} else {
								this.$message.error(res.message)
							}
						})
						.catch(err => {
							this.postLoading = false
							console.log(err)
						})
				} else {
					editUserApi(this.userForm)
						.then(res => {
							this.postLoading = false
							if (!res.errno) {
								// 操作成功直接跳转至工单详情
								this.$message.success('用户信息修改成功')
								this.dialogShow = false
								this.$emit('change')
							} else {
								this.$message.error(res.message)
							}
						})
						.catch(err => {
							this.postLoading = false
							console.log(err)
						})
				}
			})
		}
	}
}
</script>

<style lang="scss" scoped>
.user-editor {
	.f-form {
		padding: 0px 30px;
	}
	.el-input-number /deep/.el-input__inner {
		text-align: left;
	}
	/deep/.el-form-item__label {
		color: rgba(16, 16, 16, 1);
	}
}
</style>
